import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";

import "./index.scss";
import "animate.css";
import area from "@/assets/images/common/area.png";

interface ChooseLanguageProps {
  items: { name: string; value: string }[];
  onSelect?: (val: string) => void;
  selected: string;
}

const ANIMATION_IN = "animate__fadeIn";
const ANIMATION_OUT = "animate__fadeOut";
const ANIMATION_DURATION = 30; // ms

const ChooseLanguage: React.FC<ChooseLanguageProps> = ({
  items,
  onSelect,
  selected,
}) => {
  const { t } = useTranslation();

  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [visible, setVisible] = useState(false); // 是否挂载下拉菜单
  const [show, setShow] = useState(false); // 是否显示动画
  const triggerRef = useRef<HTMLDivElement | null>(null);
  const dropdownRef = useRef<HTMLDivElement | null>(null);
  const [animationType, setAnimationType] = useState<string>("");

  // 计算下拉菜单位置
  const [dropdownStyle, setDropdownStyle] = useState<React.CSSProperties>({});
  useEffect(() => {
    if (show && triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setDropdownStyle({
        position: "absolute",
        top: rect.bottom - 24,
        left: 0,
        minWidth: rect.width,
        zIndex: 1000,
      });
    }
  }, [show]);

  // 显示下拉菜单
  const handleShow = () => {
    setVisible(true);
    setShow(true);
    setAnimationType(ANIMATION_IN);
  };

  // 隐藏下拉菜单
  const handleHide = () => {
    setAnimationType(ANIMATION_OUT);

    setTimeout(() => {
      setShow(false);
      setVisible(false);
    }, ANIMATION_DURATION);
  };

  // 点击外部关闭
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      if (
        !triggerRef.current?.contains(e.target as Node) &&
        !dropdownRef.current?.contains(e.target as Node)
      ) {
        handleHide();
      }
    };
    if (show) document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [show]);

  const handleSelect = (item: { name: string; value: string }) => {
    handleHide();
    onSelect?.(item.value);
  };

  return (
    <div className='choose-language'>
      <div
        ref={triggerRef}
        className={`language-trigger ${isMobile ? "mobile" : "pc"}`}
        onClick={() => (!show ? handleShow() : handleHide())}>
        <img src={area} alt='' />
        {t("Language")}
      </div>
      {visible && (
        <div
          className={`choose-language-dropdown animate__animated ${animationType} ${
            isMobile ? "mobile" : "pc"
          }`}
          ref={dropdownRef}
          style={dropdownStyle}>
          {items.map((item) => (
            <div
              key={item.value}
              className={`choose-language-item${
                item.value === selected ? " selected" : ""
              }`}
              onClick={() => handleSelect(item)}>
              {item.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChooseLanguage;
